import { Box, useMediaQuery } from "@mui/material";
import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import React from "react";
import { Caixa } from "./QuiSom";

const QueFem = () => {
	return (
		<Caixa>
			<Typography variant="h2" color="third">
				QUÈ FEM?
			</Typography>
			<Box mt={3}>
				<Grid container spacing={3}>
					<Grid item md={3} sx={12}>
						<Typography variant="body1">
							Les{" "}
							<strong color="third">
								ACTIVITATS EXTRAESCOLARS
							</strong>{" "}
							son una de les branques principals del projecte.
							Gestionem les escoles de la ciutat de Berga i
							col.laborem amb altres empreses per tal d’oferir un
							servei integral. Des de les{" "}
							<strong>ACOLLIDES</strong> matinals, fins a
							activitats de migdia i tarda, també activitats fora
							de l’escola en altres espais.
						</Typography>
					</Grid>
					<Grid item md={3} sx={12}>
						<Typography variant="body1">
							El{" "}
							<strong color="third">
								MONITORATGE DE MENJADOR
							</strong>{" "}
							també és un dels nostres focus de treball, on al
							llarg dels anys hem creat equips competents
							provinents del lleure, que s’impliquen en aquesta
							franja diària del desenvolupament i creixement dels
							infants.
						</Typography>
					</Grid>
					<Grid item md={3} sx={12}>
						<Typography variant="body1">
							Els <strong>CASALS D’ESTIU</strong> son la nostra
							activitat durant l’estiu amb activitats de lleure i
							esport. Els últims 11 anys el Casal ha pres vida a
							Berga, però també n’hem desenvolupat en altres
							indrets de la comarca.
						</Typography>
					</Grid>
					<Grid item md={3} sx={12}>
						<Typography variant="body1">
							Els{" "}
							<strong color="third">TALLERS i JORNADES</strong> de
							lleure educatiu son propostes d’activitats concretes
							per realitzar dins i fora de l’horari lectiu. Així
							podem treballar la iniciació esportiva, les
							emocions, la cohesió i els valors en format gimcana.
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Caixa>
	);
};

export default QueFem;
